$(document).ready(function () {
	window.myDataLayer = getShoptetDataLayer();
});
